import React from 'react'
import RCTimePicker from 'rc-time-picker/lib/TimePicker'
import { use12Hours } from 'src/services'

/**
 * A component that triggers a time picker on click on its children
 */
const TimePicker = props => <RCTimePicker use12Hours={use12Hours()} {...props} />

export default TimePicker
